/**
 * WelcomeOverlay — full-viewport modal shown once per user after their first
 * paid login. Persists dismissal in localStorage under key `cw:welcomeSeen:<user_id>`.
 */
import { useEffect, useRef } from 'react';

export function WelcomeOverlay({ user, organization, onDismiss }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onDismiss();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onDismiss]);

  const onBackdropClick = (e) => {
    if (e.target === dialogRef.current) onDismiss();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className="welcome-overlay"
      onClick={onBackdropClick}
      ref={dialogRef}
    >
      <div
        className="welcome-overlay-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="welcome-overlay-title"
      >
        <h1 id="welcome-overlay-title" className="welcome-overlay-title">
          Welcome to CritWise{user?.full_name ? `, ${user.full_name.split(' ')[0]}` : ''}.
        </h1>
        <p className="welcome-overlay-lede">
          You&rsquo;re set up on <strong>{organization?.name || 'your team'}</strong>. Here&rsquo;s
          what you can do next:
        </p>
        <ul className="welcome-overlay-list">
          <li><strong>Upload schedules</strong> — drag a .xer file anywhere in the dashboard.</li>
          <li><strong>Track trends</strong> — every upload becomes a dated point on that project&rsquo;s score timeline.</li>
          <li><strong>Invite teammates</strong> — admins can add members from the Team page.</li>
        </ul>
        <button
          ref={closeRef}
          type="button"
          className="btn-submit welcome-overlay-dismiss"
          onClick={onDismiss}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
